import React, { useState } from "react";
import { Modal, Box, Button, Typography, CircularProgress } from "@mui/material";
import warning from "../../../../assets/warning.svg";
import CustomText, { textStyles } from "../../../../components/CustomText";
import CustomButton from "../../../../components/CustomButton";
import { useTranslation } from "react-i18next";
const ConfirmActionModal = ({ open, onClose, onConfirm, action }) => {
  const [reasonOrNotes, setReasonOrNotes] = useState(""); // State to hold reason/notes input
  const [loading, setLoading] = useState(false); // Loading state
const {t}=useTranslation()
  // Handler for input change
  const handleInputChange = (e) => {
    setReasonOrNotes(e.target.value);
  };

  const handleConfirm = async () => {
    setLoading(true); // Set loading to true when confirming
    try {
      await onConfirm(reasonOrNotes); // Call the onConfirm function (API call or further action)
    } catch (error) {
      console.error("Error during action:", error);
    } finally {
      setLoading(false); // Reset loading state once action is complete
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <Box sx={{ display: "flex", justifyContent: "center", mb: 1.5 }}>
          <img
            src={warning}
            alt="logout"
            style={{ width: 50, height: 50 }}
          />
        </Box>

        {/* Message */}
        <CustomText sx={{ ...textStyles.h1, fontSize: 18, fontWeight: 500, lineHeight: "32px", color: "#2C384C" }}>
         {t('confirmActionModal.title', { action })}
        </CustomText>

      
        <label htmlFor="reasonOrNotes" style={{ display: "block", marginBottom: "8px" }}>
          {action === "cancel" ? t('confirmActionModal.reasonLabel') : t('confirmActionModal.notesLabel')}
        </label>

        <textarea
          id="reasonOrNotes"
          className="project_input"
          placeholder={action === "cancel" ? t('confirmActionModal.reasonPlaceholder') : t('confirmActionModal.notesPlaceholder')}
          value={reasonOrNotes}
          onChange={handleInputChange}
          style={{
            width: "100%",
            height: "90px",
            
          }}
        />

        <Box sx={{ display: "flex", justifyContent: "flex-end",mt:2, }}>
          {/* No Button */}
          <CustomButton
            onClick={onClose}
            size="medium"
            label={<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>{t('confirmActionModal.cancelButton')}</Box>}
            sx={{
              color: "#172B4D",
              backgroundColor: "white",
              "&:hover": {
                backgroundColor: "white", // same as normal
                color: "#172B4D", // same as normal
              },
            }}
          />

          {/* Yes Button with loading indicator */}
          <CustomButton
            onClick={handleConfirm}
            disabled={loading}
            size="medium"
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {loading && (
                  <CircularProgress size={18} thickness={4} sx={{ color: "#ffffff" }} />
                )}
                             {t('confirmActionModal.confirmButton')}
              </Box>
            }
          />
        </Box>
      </Box>
    </Modal>
  );
};

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "white",
  padding: 3,
  boxShadow: 24,
  borderRadius: "8px",
};

export default ConfirmActionModal;
